// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrollbar-inner .scroll-element.scroll-y[data-v-73d9feac]{\n  background-color: #e5e5e594 !important;\n  width: 8px !important;\n  opacity: 1 !important;\n}\n.scrollbar-inner > .scroll-element .scroll-element_track[data-v-73d9feac], .scrollbar-inner > .scroll-element .scroll-bar[data-v-73d9feac]{\n  opacity: unset!important;\n}\n.loader.force-right-0[data-v-73d9feac]{\n  right:0!important;\n}\n", ""]);
// Exports
module.exports = exports;
